import { getRouteApi, Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { AddToListDialog } from "../ui/AddToListDialog";
import { SitePanel, TABS, type TabId } from "../ui/site/SitePanel";
import { useToast } from "../ui/Toast";

const route = getRouteApi("/sites/$id");

/** Full-page site detail; the same panel opens as a drawer from the map (PRD §12.1). */
export function SitePage() {
  const { id } = route.useParams();
  const search = route.useSearch();
  const navigate = useNavigate({ from: "/sites/$id" });
  const toast = useToast();
  const siteId = Number(id);
  const [dialogOpen, setDialogOpen] = useState(false);
  const tab = (TABS.some((t) => t.id === search.tab) ? search.tab : "overview") as TabId;

  if (!Number.isInteger(siteId) || siteId < 1) {
    return (
      <div className="p-6">
        <p style={{ color: "var(--danger)" }}>Bad site id.</p>
        <Link to="/">Back to map</Link>
      </div>
    );
  }
  return (
    <div className="mx-auto flex h-full max-w-6xl flex-col">
      <div className="flex items-center gap-3 px-4 pt-3 text-[12px]">
        <Link to="/" search={{ site: siteId }}>
          ← Map
        </Link>
        <Link to="/table">Table</Link>
      </div>
      <div className="min-h-0 flex-1">
        <SitePanel
          siteId={siteId}
          tab={tab}
          onTab={(t) =>
            void navigate({
              search: (prev) => ({ ...prev, tab: t === "overview" ? undefined : t }),
              replace: true,
            })
          }
          verify={null}
          variant="page"
          onAddToList={() => setDialogOpen(true)}
        />
      </div>
      <AddToListDialog
        open={dialogOpen}
        siteIds={[siteId]}
        onClose={() => setDialogOpen(false)}
        onDone={(_l, name) => toast(`Added to ${name}`)}
      />
    </div>
  );
}
